"use strict";
// tslint:disable
/**
 * Speedtest Plus API
 * This is the API for Speedtest Plus
 *
 * The version of the OpenAPI document: 0.46.0
 * Contact: speedtest-api@anw.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceModelDeviceTypeEnum = void 0;
/**
 * @export
 * @enum {string}
 */
var DeviceModelDeviceTypeEnum;
(function (DeviceModelDeviceTypeEnum) {
    DeviceModelDeviceTypeEnum["Mobile"] = "mobile";
    DeviceModelDeviceTypeEnum["Tablet"] = "tablet";
    DeviceModelDeviceTypeEnum["Desktop"] = "desktop";
    DeviceModelDeviceTypeEnum["Settop"] = "settop";
    DeviceModelDeviceTypeEnum["Crawler"] = "crawler";
})(DeviceModelDeviceTypeEnum = exports.DeviceModelDeviceTypeEnum || (exports.DeviceModelDeviceTypeEnum = {}));
//# sourceMappingURL=DeviceModel.js.map